import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { APIOnLine } from '../../services/api/api.services';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { Online } from '../../models/online/cfutbol';
import { iConfiguracion } from '../../models/basePage';

@IonicPage()
@Component({
  selector: 'page-salir',
  templateUrl: 'salir.html',
})
export class SalirPage {

  // #region Propiedades del controlador
  public arbitro: pouchdb2.ArbitroBasicoDB | Online.ArbitroBasico;
  public configuraciones: iConfiguracion;
  // #endregion

  constructor(
    public navCtrl: NavController,
    public DBService2: pouchdb2.DBService2,
    public Persistentes: APIOnLine.Persistentes
  ) {
    this.arbitro = this.Persistentes.GetArbitro();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SalirPage');
    this.arbitro = this.Persistentes.GetArbitro();

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
      });
  }

  public salir(): void {
    this.Persistentes.SetArbitro(null);
    this.Persistentes.SetIdEquipo(0);
    this.navCtrl.setRoot(LoginPage);
    this.navCtrl.first();
  }

  public eliminar(): void {
    this.Persistentes.SetArbitro(null);
    this.Persistentes.SetIdEquipo(0);
    if (this.configuraciones.online) {
      this.DBService2.destroy();
      console.log("Base de datos eliminada");
    }
    this.navCtrl.setRoot(LoginPage);
    this.navCtrl.first();
  }

}



// WEBPACK FOOTER //
// ./src/pages/salir/salir.ts